<template>
  <div class="empty-cart-wrapper">
    <div class="empty-cart">
      <img src="/assets/images/cart_replace.svg" alt="cart icon">
      <span class="empty-cart-title">{{ $t('checkout.emptyCart.cartIsEmpty') }}</span>
      <span class="empty-cart-subtitle">{{ $t('checkout.emptyCart.checkOurOffer') }}</span>
      <a href="/" class="btn theme-btn">{{ $t('checkout.emptyCart.goToHomePage') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty-cart'
}
</script>

<style lang="scss" scoped>
.empty-cart-wrapper {
  padding: 0 2rem;

  @media (map_get($breakpoints, sm)) {
    padding: 0 4rem;
  }
}

.empty-cart {
  border-radius: .5rem;
  margin: 25vh auto 0;
  padding: 2.4rem;
  max-width: 80rem;
  width: 100%;
  background: $white;
  text-align: center;

  @media (map_get($breakpoints, sm)) {
    padding: 4.8rem;
  }

  .btn {
    width: auto;
    min-width: 24rem;
  }
}

.empty-cart-title {
  display: block;
  margin-top: 2.4rem;
  margin-bottom: 1.6rem;
  color: $text;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    font-size: 2.4rem;
  }
}

.empty-cart-subtitle {
  display: block;
  margin-bottom: 4rem;
  color: $dark-grey;
}
</style>
